declare global {
  interface Window {
    pwr: {
      (action: 'render', config: object): void
      q?: ['render', object][]
    }
  }
}

export default createGlobalState(() => {
  const locale = useLocale()
  const [countryLanguage] = locale.split('-')
  const { configPowerReview } = useFeatureFlags()
  let stylesElement: HTMLLinkElement | null

  useScript('https://ui.powerreviews.com/stable/4.1/ui.js', {
    mode: 'client'
  })

  const render = (writeId, page_id, page_id_variant) => {
    if (stylesElement) document.head.append(stylesElement)
    window.pwr('render', {
      api_key: configPowerReview.apiKey,
      merchant_group_id: configPowerReview.merchantGroup,
      merchant_id: configPowerReview.merchantId[countryLanguage],
      locale: getMappedLocale(locale),
      page_id,
      page_id_variant,
      components: { Write: writeId }
    })
  }

  const destroy = () => {
    stylesElement ||= document.querySelector('[href*="ui.powerreviews.com"]')
    if (stylesElement) stylesElement.remove()
  }

  onMounted(() => {
    window.pwr = window.pwr || function (...args) {
      window.pwr.q ??= []
      window.pwr.q.push(args)
    }
  })

  return {
    render,
    destroy
  }
})
